import { NotificationService } from '../notification/notification.service';

export const wrapPromiseWithNotify = <T>(
	promise: Promise<T>,
	successMessage: string,
	srv: NotificationService,
	alternateErrorMessage?: string,
) => {
	return promise
		.then((result) => {
			// Show success notification
			srv.addNotification({
				id: window.crypto.randomUUID(),
				type: 'success',
				message: successMessage,
				showToast: true,
				timestamp: new Date(),
			});
			return result;
		})
		.catch((error) => {
			// Show error notification
			srv.addNotification({
				id: window.crypto.randomUUID(),
				type: 'error',
				message: error.message || alternateErrorMessage || 'Fehler aufgetreten',
				showToast: true,
				timestamp: new Date(),
			});
			throw error;
		});
};
